import { useTranslation } from '@wix/wix-i18n-config';
import { useViewport } from './useViewport';

export const useTranslationWithMobile = () => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useViewport();

  const tm = (key: string) => t(isMobile ? `${key}_MOBILE` : key);

  return { t, tm, i18n };
};
